import React from 'react'
import PropTypes from 'prop-types'

const CellUserName = ({ userName }) => {
    return (
        <>
            <div className="w-full flex-grow h-full flex flex-row items-center justify-between">
                <p className="text-base md:font-medium font-medium md:text-textDarkerGray text-black90">
                    {userName}
                </p>
            </div>
        </>
    )
}

CellUserName.propTypes = {
    userName: PropTypes.string,
}

export default CellUserName
